import { createContext } from 'react';
import { HistoryFieldDescriptor } from './history-types';

export interface HistoryContextType {
  descriptors: HistoryFieldDescriptor[];
}

export const HistoryContext = createContext<HistoryContextType>({} as any);
